import { PlanDetailSection } from 'modules';


// type IFieldName = 'fileSize' | 'createdTimestamp' | 'updatedTimestamp' | 'fileType' | 'uploadedBy' | 'title';


export type PlanActivityProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const PlanActivity = (props: PlanActivityProps) => {

  return (
    <PlanDetailSection.FC />
  );
};
